import "./Resources.module.css";
import Header from "@/reusable_sections/Header";
import BlogHero from "./sections/BlogHero";
import BlogListing from "./sections/BlogListing";
import SubscribeCta from "./sections/SubscribeCta";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function ResourcesPage() {
  return <div>
      <Header />
      <BlogHero />
      <BlogListing />
      <SubscribeCta />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}